import type { ReactNode } from 'react';

export const symbol_pediatrics: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M320-700q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h130v-90q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v90h130q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H320Zm20 620q-24.75 0-42.37-17.63Q280-115.25 280-140v-390q0-50 35-85t85-35h160q50 0 85 35t35 85v390q0 24.75-17.62 42.37Q644.75-80 620-80H340Zm0-60h280v-390q0-25.5-17.25-42.75T560-590H400q-25.5 0-42.75 17.25T340-530v50h100q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H340v110h100q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H340v110Zm0 0v-450 450Z"
		/>
	</svg>
);
